import { Box, Typography } from "@mui/material";
import { CollapsibleTable, CollapsibleTableCell, DataAutomation } from "../CollapsibleTable";
import { summaryHeaderStyle, textHighlightStyle } from "./styled";

interface ISummaryTableProps {
  tbd: number,
  totAvRaw: number,
  eligible: number,
  notEligible: number,
  avForcedIn: number,
  avAndAVForcedIn: number,
  unmatched: number,
  summaryMessage: string
}

export const SummaryTable: React.FC<ISummaryTableProps> = ({
  tbd, totAvRaw, eligible, notEligible, avForcedIn, avAndAVForcedIn, unmatched, summaryMessage
}) => {
  const doaSummaryCols: CollapsibleTableCell[] = [
    'Jobs/Employees', 'Counts'
  ].map(title => ({ title }));

  const dataAutomation: DataAutomation = {
    header: "summary-cols",
    rows: "summary-rows",
    columns: [
      "jobs-employees-col",
      "count-col"
    ]
  }

  const doaSummaryRows = [
    [<Typography>Jobs Ordered</Typography>, tbd],
    [
      <Typography>DOA Employees</Typography>,
      <Typography sx={textHighlightStyle}>{totAvRaw}</Typography>
    ],
    [
      <Typography sx={{ pl: 1 }}>- Employees Eligible</Typography>,
      <Typography sx={textHighlightStyle}>{eligible}</Typography>
    ],
    [
      <Typography sx={{ pl: 1 }}>- Employees Not Eligible</Typography>,
      <Typography sx={textHighlightStyle}>{notEligible}</Typography>
    ],
    [<Typography>Employees contacted past cut-off times</Typography>, avForcedIn],
    [<Typography>Matched jobs from DOA pool</Typography>, avAndAVForcedIn],
    [<Typography>Unfilled jobs from DOA pool</Typography>, unmatched],
  ];

  return (
    <Typography
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >
      <Typography sx={summaryHeaderStyle} data-automation="doa-tbl-title">
        Declaration of Availability Summary (DOA) {summaryMessage}
      </Typography>
      <Box sx={{ overflow: "auto" }}>
        <CollapsibleTable
          size="custom"
          cols={doaSummaryCols}
          rows={doaSummaryRows}
          dataAutomation={dataAutomation}
          isOneLevel
        />
      </Box>
    </Typography>
  )
}